export const MAX_LENGTH_CAP = 5;
export const MAX_LENGTH_PROVINCIA = 2;
export const MAXIMUM_FILE_SIZE = {
  byte: 8097152,
  value: '7.7MB',
};
